import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

import ProjectSitePlan from "~/components/organisms/ProjectSitePlan";
import SectionProject from "~/components/templates/SectionProject";
import { IProject } from "~/entities/project";

export interface SectionProjectSitePlanProps {
  className?: string;
  id: string;
  title: string;
  description: string;
  project: IProject;
}

export type Ref = HTMLDivElement;

const SectionProjectInfo = forwardRef<Ref, SectionProjectSitePlanProps>(
  ({ className = "", id, title, description, project }, ref) => {
    const { t } = useTranslation();
    if (!project) return null;

    return (
      <SectionProject ref={ref} id={id} className={className}>
        <ProjectSitePlan
          title={t(title)}
          description={t(description)}
          sitePlanImages={project.sitePlanImage}
          sitePlanData={project?.facilityHtml || ""}
        />
      </SectionProject>
    );
  }
);

SectionProjectInfo.displayName = "SectionProjectInfo";

export default SectionProjectInfo;
